<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="d-flex align-center">
          <h2 class="headline">
            <span class="font-weight-bold d-flex align-center">
              <v-icon class="mr-3 black--text" @click="goBack()">
                mdi-arrow-left
              </v-icon>
              {{ $t('your_order') }}
            </span>
          </h2>
          <v-spacer />
          <h3 class="link-text primary--text" @click="goToHistory()">
            {{ $t('history') }}
          </h3>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <template v-if="$store.state.selected_store">
          <v-chip
            small
            :outlined="selected[0] === true ? false : true"
            :color="selected[0] === true ? 'primary' : 'grey'"
            class="mr-2 mb-1 px-2 line-height-regular"
            @click="filterOrders(0, 'all')"
          >
            All
          </v-chip>
          <v-chip
            :disabled="($store.state.selected_store.setting.use_takeaway === 0) ? true : false"
            small
            :outlined="selected[1] === true ? false : true"
            :color="selected[1] === true ? 'primary' : 'grey'"
            class="mr-2 mb-1 px-2 line-height-regular"
            @click="filterOrders(1, 'is_takeaway')"
          >
            {{ $t('takeaway') }}
          </v-chip>
          <v-chip
            :disabled="($store.state.selected_store.setting.use_delivery === 0) ? true : false"
            small
            :outlined="selected[2] === true ? false : true"
            :color="selected[2] === true ? 'primary' : 'grey'"
            class="mr-2 mb-1 px-2 line-height-regular"
            @click="filterOrders(2, 'is_delivery')"
          >
            {{ $t('delivery') }}
          </v-chip>
          <v-chip
            :disabled="($store.state.selected_store.setting.use_reservation === 0) ? true : false"
            small
            :outlined="selected[3] === true ? false : true"
            :color="selected[3] === true ? 'primary' : 'grey'"
            class="mr-2 mb-1 px-2 line-height-regular"
            @click="filterOrders(3, 'is_reservation')"
          >
            {{ $t('reservation') }}
          </v-chip>
          <v-chip
            :disabled="($store.state.selected_store.setting.use_dinein === 0) ? true : false"
            small
            :outlined="selected[4] === true ? false : true"
            :color="selected[4] === true ? 'primary' : 'grey'"
            class="mr-2 mb-1 px-2 line-height-regular"
            @click="filterOrders(4, 'is_dinein')"
          >
            {{ $t('dinein') }}
          </v-chip>
        </template>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <template v-if="orders.length === 0">
          <div class="px-3 my-5">
            <div class="mx-auto d-flex justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="253.734" height="201.242" viewBox="0 0 253.734 201.242" class="no_data--img">
                <defs>
                  <linearGradient id="a" x1="0.509" y1="0.997" x2="0.509" y2="-0.003" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="gray" stop-opacity="0.251" />
                    <stop offset="0.54" stop-color="gray" stop-opacity="0.122" />
                    <stop offset="1" stop-color="gray" stop-opacity="0.102" />
                  </linearGradient>
                  <linearGradient id="b" x1="0.813" y1="0.841" x2="0.813" y2="-0.159" xlink:href="#a" />
                  <linearGradient id="c" x1="1.78" y1="0.849" x2="1.78" y2="-0.151" xlink:href="#a" />
                  <linearGradient id="d" x1="0.5" y1="1" x2="0.5" y2="0" xlink:href="#a" />
                  <linearGradient id="f" x1="0.5" y1="0.999" x2="0.5" y2="-0.001" xlink:href="#a" />
                </defs>
                <g transform="translate(37.488 32.609)">
                  <path class="a" d="M236.861,41.749c8.609-7.663,22.122-9.233,34.423-8.623C309.919,35.047,344.793,53.7,374.96,74.8c10.922,7.636,21.674,15.868,28.761,26.386,14.441,21.411,10.15,51.072-9.914,68.71-6.829,6-15.1,10.61-23.6,14.68-15.107,7.25-31.408,13.071-48.555,14.736-12.225,1.179-24.6.221-36.76-1.426-33.96-4.615-67.29-14.8-95.238-32.224-12.254-7.642-23.8-17.144-28.856-29.5s-1.818-28.036,10.7-35.366c5.175-3.027,11.364-4.394,17.421-5.679,8.918-1.889,17.978-3.752,26.024-7.592,8.314-3.967,18.155-11.638,16.5-20.421C229.685,57.687,228.264,49.412,236.861,41.749Z" transform="translate(-196.003 -65.616)" />
                  <rect class="b" width="94.384" height="130.408" transform="matrix(0.978, -0.21, 0.21, 0.978, 14.928, 29.262)" />
                  <g class="c" transform="translate(16.951 11.952)">
                    <rect class="d" width="91.194" height="126" transform="matrix(0.978, -0.21, 0.21, 0.978, 0, 19.132)" />
                  </g>
                  <rect class="e" width="88.873" height="123.216" transform="matrix(0.978, -0.21, 0.21, 0.978, 18.28, 31.747)" />
                  <rect class="f" width="44.089" height="10.68" transform="matrix(0.978, -0.21, 0.21, 0.978, 39.167, 21.802)" />
                  <path class="g" d="M443.334,91.408a6.311,6.311,0,1,0,7.343,4.877A6.237,6.237,0,0,0,443.334,91.408Zm2.088,9.74a3.641,3.641,0,1,1,2.713-4.319,3.6,3.6,0,0,1-2.713,4.319Z" transform="translate(-384.803 -84.43)" />
                  <rect class="h" width="43.16" height="10.209" transform="matrix(0.978, -0.21, 0.21, 0.978, 39.525, 21.256)" />
                  <path class="h" d="M443.623,91.408a6.032,6.032,0,1,0,7.164,4.633A6.032,6.032,0,0,0,443.623,91.408Zm2,9.308a3.481,3.481,0,1,1,2.674-4.134A3.481,3.481,0,0,1,445.619,100.716Z" transform="translate(-385.092 -84.43)" />
                  <rect class="b" width="94.384" height="130.408" transform="translate(55.697 25.249)" />
                  <g class="c" transform="translate(57.293 27.454)">
                    <rect class="i" width="91.194" height="126" />
                  </g>
                  <rect class="j" width="88.873" height="123.216" transform="translate(58.453 28.383)" />
                  <rect class="i" width="44.089" height="10.68" transform="translate(80.962 23.04)" />
                  <path class="k" d="M644.484,118a6.312,6.312,0,1,0,6.164,6.311A6.239,6.239,0,0,0,644.484,118Zm0,9.952a3.641,3.641,0,1,1,3.555-3.641,3.6,3.6,0,0,1-3.555,3.624Z" transform="translate(-541.478 -105.385)" />
                  <rect class="h" width="43.16" height="10.209" transform="translate(81.426 22.582)" />
                  <path class="h" d="M644.962,118a6.032,6.032,0,1,0,6.032,6.032A6.032,6.032,0,0,0,644.962,118Zm0,9.514a3.5,3.5,0,1,0,0-.011Z" transform="translate(-541.956 -105.385)" />
                  <g class="c" transform="translate(1.402 159.182)">
                    <rect class="l" width="0.812" height="4.607" transform="translate(1.896)" />
                    <rect class="l" width="0.812" height="4.607" transform="translate(4.607 1.898) rotate(90)" />
                  </g>
                  <g class="c" transform="translate(95.613)">
                    <rect class="l" width="0.812" height="4.607" transform="translate(1.896)" />
                    <rect class="l" width="0.812" height="4.607" transform="translate(4.607 1.896) rotate(90)" />
                  </g>
                  <path class="m" d="M948.919,825.463a1,1,0,0,1-.555-1.2.484.484,0,0,0,.022-.11h0a.5.5,0,0,0-.9-.33h0a.482.482,0,0,0-.056.1,1,1,0,0,1-1.2.555.48.48,0,0,0-.11-.022h0a.5.5,0,0,0-.33.9h0a.478.478,0,0,0,.1.056,1,1,0,0,1,.555,1.2.481.481,0,0,0-.022.11h0a.5.5,0,0,0,.9.33h0a.479.479,0,0,0,.056-.1,1,1,0,0,1,1.2-.555.484.484,0,0,0,.11.022h0a.5.5,0,0,0,.33-.9h0A.484.484,0,0,0,948.919,825.463Z" transform="translate(-782.387 -658.611)" />
                  <path class="n" d="M314.509,620.4a1,1,0,0,1-.555-1.2.48.48,0,0,0,.022-.11h0a.5.5,0,0,0-.9-.33h0a.482.482,0,0,0-.056.1,1,1,0,0,1-1.2.555.48.48,0,0,0-.11-.022h0a.5.5,0,0,0-.33.9h0a.482.482,0,0,0,.1.056,1,1,0,0,1,.555,1.2.478.478,0,0,0-.022.11h0a.5.5,0,0,0,.9.33h0a.481.481,0,0,0,.056-.1,1,1,0,0,1,1.2-.555.48.48,0,0,0,.11.022h0a.5.5,0,0,0,.33-.9h0A.481.481,0,0,0,314.509,620.4Z" transform="translate(-284.992 -497.839)" />
                  <path class="n" d="M842.919,121.083a1,1,0,0,1-.555-1.2.48.48,0,0,0,.022-.11h0a.5.5,0,0,0-.9-.33h0a.479.479,0,0,0-.056.1,1,1,0,0,1-1.2.555.479.479,0,0,0-.11-.022h0a.5.5,0,0,0-.33.9h0a.481.481,0,0,0,.1.056,1,1,0,0,1,.555,1.2.477.477,0,0,0-.022.11h0a.5.5,0,0,0,.9.33h0a.482.482,0,0,0,.056-.1,1,1,0,0,1,1.2-.555.479.479,0,0,0,.11.022h0a.5.5,0,0,0,.33-.9h0A.479.479,0,0,0,842.919,121.083Z" transform="translate(-699.28 -106.358)" />
                  <circle class="o" cx="1.626" cy="1.626" r="1.626" transform="translate(173.881 66.291)" />
                  <circle class="o" cx="1.626" cy="1.626" r="1.626" transform="translate(48.205 159.629)" />
                  <circle class="o" cx="1.626" cy="1.626" r="1.626" transform="translate(157.18 101.442)" />
                  <circle class="m" cx="1.626" cy="1.626" r="1.626" transform="translate(17.194 19.183)" />
                  <circle class="p" cx="1.626" cy="1.626" r="1.626" transform="translate(0 63.546)" />
                  <g transform="translate(25.067 -22.334) rotate(14)">
                    <g class="q" transform="translate(72.482 77.912)">
                      <rect class="s" width="62" height="26" />
                      <rect class="t" x="0.5" y="0.5" width="61" height="25" />
                    </g>
                    <text class="r" transform="translate(103.482 96.912)">
                      <tspan x="-25.578" y="0">
                        EMPTY
                      </tspan>
                    </text>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </template>
        <v-list v-else v-scroll="onScroll" class="order-list">
          <template v-for="(item, idx) in orders">
            <div :key="idx" class="new-list-item" @click="goToDetail(item.id)">
              <div class="primary new-list-avatar">
                <v-img v-if="item.remark === 'RESERVATION'" src="@/assets/images/svg/order_reservation.svg" contain />
                <v-img v-else-if="item.remark === 'OL-TAKE-AWAY'" src="@/assets/images/svg/order_takeaway.svg" contain />
                <v-img v-else-if="item.remark === 'DELIVERY'" src="@/assets/images/svg/order_delivery.svg" contain />
                <v-img v-else-if="item.remark === 'OL-DINE-IN'" src="@/assets/images/svg/order_dinein.svg" contain />
              </div>
              <div class="new-item-content">
                <div class="item-store-name">
                  {{ item.store_name }}
                </div>
                <div v-if="isHotels" class="item-list-item font-weight-bold">
                  <div>
                    {{ $t('order_number') }}: {{ item.order_no }}
                  </div>
                  <div>
                    {{ $t('custom.hotel.room_number') }}: {{ item.notes }}
                  </div>
                </div>
                <div v-else class="item-remart">
                  {{ item.remark }}
                </div>
                <div class="item-list-item">
                  <template v-for="(child, key) in item.items">
                    {{ child.item_name }}
                    <span v-if="(item.items.length - key) != 1" :key="key + '-plus'" v-html="'+'" />
                  </template>
                </div>
                <div class="item-status">
                  <span :class="[`font-weight-bold`, { 'status-prepering' : item.status_inquiry === 2 || item.status_inquiry === 3 }, { 'status-pending' : item.status_inquiry === 1 }]">
                    {{ item.status_desc }}
                  </span>
                </div>
              </div>
              <div class="new-item-additional">
                <span v-mask-money-only="item.total_amount" class="font-weight-bold item-price" />
              </div>
            </div>
            <!-- <v-list-item :key="idx.id" @click="goToDetail(item.id)">
              <v-list-item-avatar size="40" class="order_history_avatar primary">
                <template v-if="item.remark === 'RESERVATION'">
                  <v-img src="@/assets/images/svg/order_reservation.svg" contain />
                </template>
                <template v-else-if="item.remark === 'OL-TAKE-AWAY'">
                  <v-img src="@/assets/images/svg/order_takeaway.svg" contain />
                </template>
                <template v-else-if="item.remark === 'DELIVERY'">
                  <v-img src="@/assets/images/svg/order_delivery.svg" contain />
                </template>
                <template v-else-if="item.remark === 'DINE-IN'">
                  <v-img src="@/assets/images/svg/order_dinein.svg" contain />
                </template>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="font-weight-bold title-orders" v-html="item.remark" />
                <v-list-item-subtitle class="items font-weight-bold font-12 mt-1 mb-2">
                  <template v-for="(child, key) in item.items">
                    {{ child.item_name }}
                    <span v-if="(item.items.length - key) != 1" :key="key + '-plus'" v-html="'+'" />
                  </template>
                </v-list-item-subtitle>
                <v-list-item-subtitle :class="[`font-12`, { 'list-item-pending' : item.status_inquiry === 1 }]">
                  <span :class="[`font-weight-bold`, { 'status-prepering' : item.status_inquiry === 2 || item.status_inquiry === 3 }, { 'status-pending' : item.status_inquiry === 1 }]">
                    {{ item.status_desc }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <span v-mask-money-only="item.total_amount" class="font-weight-bold subtitle-1" />
              </v-list-item-action>
            </v-list-item> -->
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { debounce } from 'debounce'
import {
  getData as getDataOrder
} from '@/api/order'
export default {
  data() {
    return {
      selected: [true],
      settingScroll: false,
      params: {
        type: 'all',
        page: 1,
        per_page: 10
      },
      orders: []
    }
  },
  computed: {
    isHotels() {
      const url_hotel = this.$store.state.store_hotels
      const url_id = this.$store.state.url_domain
      if (url_hotel.indexOf(url_id) !== -1) {
        return true
      }
      return false
    }
  },
  created() {
    if (this.$store.state.auth_data.auth_by === 'SYSTEM' && this.$store.state.selected_outlet.setting.no_auth_dinein) {
      const historyOrder = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_history_order'))
      if (historyOrder && historyOrder.length) {
        // gabung array history ke this.orders
        this.orders.push(...historyOrder)
      }
    } else {
      this.fetchOrders()
    }
  },
  methods: {
    goToHistory() {
      this.$router.push({ name: 'transactions' }).catch(() => {})
    },
    onScroll: debounce(async function(e) {
      if (this.settingScroll === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.fetchOrders()
        }
      }
    }, 500),
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    async fetchOrders() {
      var _params = {
        page: this.params.page++,
        per_page: this.params.per_page,
        sort_column: 'order_time',
        sort_type: 'desc'
      }
      if (this.params.type === 'all') {
        _params.search_column = 'status_inquiry'
        _params.search_operator = 'in'
        _params.search_text = '1,2,3,4,6'
      } else if (this.params.type === 'is_takeaway') {
        _params.search_column = ['status_inquiry', 'remark']
        _params.search_operator = ['in', '=']
        _params.search_text = ['1,2,3,4,6', 'OL-TAKE-AWAY']
      } else if (this.params.type === 'is_delivery') {
        _params.search_column = ['status_inquiry', 'remark']
        _params.search_operator = ['in', '=']
        _params.search_text = ['1,2,3,4,6', 'DELIVERY']
      } else if (this.params.type === 'is_reservation') {
        _params.search_column = ['status_inquiry', 'remark']
        _params.search_operator = ['in', '=']
        _params.search_text = ['1,2,3,4,6', 'RESERVATION']
      } else if (this.params.type === 'is_dinein') {
        _params.search_column = ['status_inquiry', 'remark']
        _params.search_operator = ['in', '=']
        _params.search_text = ['1,2,3,4,6', 'OL-DINE-IN']
      }
      try {
        const { data } = await getDataOrder(_params)
        this.settingScroll = (data.data.length < this.params.per_page)
        this.$store.state.loading_axios = false
        for (var i in data.data) {
          this.orders.push(data.data[i])
        }
      } catch (e) {
        this.settingScroll = true
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goToDetail(idOrder) {
      this.$router.push({ name: 'order', params: { id: idOrder }}).catch(() => {})
    },
    filterOrders(idx, _type) {
      this.params.page = 1
      this.params.per_page = 10
      this.orders = []
      this.selected = []
      this.selected[idx] = true
      this.params.type = _type
      this.fetchOrders()
    }
  }
}
</script>
